// Version: 1.0 - Footer Component
import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <span className="logo-text">headache<span className="logo-md">MD</span></span>
                <span className="logo-er">ER</span>
              </div>
              <p className="footer-tagline">
                A concept for specialized emergency headache care
              </p>
              <div className="footer-disclaimer">
                <strong>Important:</strong> This is a concept website only. 
                Not affiliated with any ER facility.
              </div>
            </div>

            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About This Concept</a></li>
                <li><a href="#services">Envisioned Services</a></li>
                <li><a href="#when-to-visit">When to Visit ER</a></li>
                <li><a href="#find-er">Find an ER</a></li>
              </ul>
            </div>

            <div className="footer-links">
              <h4>headacheMD Network</h4>
              <ul>
                <li>
                  <a href="https://www.headacheMD.org" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-external-link-alt"></i> headacheMD.org
                  </a>
                </li>
                <li>
                  <a href="https://headache.zone" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-external-link-alt"></i> Headache Zone
                  </a>
                </li>
                <li>
                  <a href="https://www.headacheMD.org/medicaldisclaimer" target="_blank" rel="noopener noreferrer">
                    Medical Disclaimer
                  </a>
                </li>
                <li>
                  <a href="https://www.headacheMD.org/privacypolicy" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-emergency">
              <h4>Emergency Contact</h4>
              <div className="emergency-box">
                <div className="emergency-icon">
                  <i className="fa fa-phone-alt"></i>
                </div>
                <div className="emergency-info">
                  <span>For emergencies, call</span>
                  <strong>911</strong>
                </div>
              </div>
              <p className="emergency-note">
                Always call 911 or go to your nearest emergency room for 
                medical emergencies.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} headacheMD LLC. All rights reserved. 
              headacheMD ER is a concept website.
            </p>
            <p className="disclaimer-note">
              This website is for informational purposes only and does not 
              constitute medical advice. If you are experiencing a headache emergency, 
              please call 911 or visit your nearest emergency room immediately.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
